<div class="relative w-full">
  <div class="flex justify-between items-center">
    <span class="block text-xs font-medium text-[#757575]"
    [ngClass]="{
      'text-[#757575]': !isDisabled,
      'text-[#C2C2C2]': isDisabled
    }">
      {{ label }}
    </span>

  </div>

  <div class="relative">
    <input
      [type]="type === 'password' && !isPasswordVisible ? 'password' : 'text'"
      [placeholder]="placeholder"
      [formControl]="control"
      [readOnly]="isReadonly"
      (focus)="isFocused = true"
      (blur)="isFocused = false"
      [ngClass]="inputClasses"
      class="h-[48px] rounded-[16px] mt-1 text-[#272B34] text-[16px] font-semibold placeholder-[#757575] placeholder:font-normal border-[1px] border-[#C2C2C2] focus:outline-none focus:border-[2px]"
    />

    @if (type === "text") {
      <span class="absolute left-4 top-1/2 transform -translate-y-1/2 text-[#728197] mt-[4px] ">
        <i class="fi fi-rs-search text-[19px]"></i>
      </span>
    }

    @if (type === "password") {
      <button
      [ngClass]="{
        'text-[#272B34]': !isDisabled,
        'text-[#C2C2C2]': isDisabled,
      }"

        [disabled]="isDisabled"
        type="button"
        (click)="togglePasswordVisibility()"
        class="absolute right-2 top-1/2 transform -translate-y-1/2  mt-1 mr-2"
      >
        <i [ngClass]="isPasswordVisible ? 'fi fi-sr-eye-crossed text-[22px] ' : ' fi fi-rr-eye text-[22px] '"></i>
      </button>
    }



    @if (type === "text" && (isFocused || control.value)) {

      <button
        type="button"
        (click)="clearInput()"
        class="absolute right-2 top-1/2 transform -translate-y-1/2 text-[#1A212B] mt-1"
      >
        <i class="fi fi-sr-cross-small text-[20px]"></i>
      </button>
    }

  </div>


  @if (control.invalid && control.touched && type !== 'text' && !isReadonly) {
    <div class="flex ml-3">
      <span [ngClass]="{
        'mt-1': getErrorMessage() === 'Este campo es requerido' || getErrorMessage() === 'Introduce una dirección de correo válida',
        'mt-3 ': getErrorMessage() === 'Mínimo 8 caracteres, con una mayúscula, una minúscula y un número'
      }"><i class="fi fi-ss-triangle-warning text-[#FF3030] text-[14px] mr-1 "></i></span>
      <p class="text-[#FF3030] text-[12px] text-start mt-1 font-semibold">{{ getErrorMessage() }}</p>
    </div>

  }
</div>
